import { Flex } from '../../../../Flex';
import { Text } from '../../../../Text';
import React from 'react';

import { Size } from '../Enums/Size';
import { TitleWeight } from '../Enums/TitleWeight';

import textStyles from './TimeRangeSection.module.css';

/**
 *Defines the properties of the component.
 *
 * @export
 * @interface ITimeRangeProps
 * @extends {TimeRangeData}
 * @extends {TextRenderingModification}
 */
export interface ITimeRangeProps {
  /**
   *The start of the time range.
   *
   * @type {string}
   * @memberof ITimeRangeData
   */
  from: string;

  /**
   *The end of the time range.
   *
   * @type {string}
   * @memberof ITimeRangeData
   */
  to: string;
  textSize?: Size;
  textWeight?: TitleWeight;
  temporary?: boolean;
  /**
   *Defines whether the text is stroke through.
   *
   * @type {boolean}
   * @memberof TextRenderingModification
   */
  strikeThrough?: boolean;
}

/**
 *A component to display a time range.
 *
 * @param {*} props
 * @return {*}
 */
const TimeRangeSection: React.FC<ITimeRangeProps> = props => {
  const textModification =
    props.strikeThrough === undefined || !props.strikeThrough
      ? ''
      : textStyles.strikeThrough;

  const textSize: Size = props.textSize ?? Size.Small;
  const textWeight: TitleWeight = props.textWeight ?? TitleWeight.Regular;
  return (
    <Flex inline>
      <Text
        className={textModification || undefined}
        size={textSize}
        weight={textWeight}
        color={props.temporary ? 'muted' : undefined}
      >
        {props.from}
      </Text>
      <Text
        className={textModification || undefined}
        size={textSize}
        weight={textWeight}
        color={props.temporary ? 'muted' : undefined}
        style={{ padding: '0 5px' }}
      >
        -
      </Text>
      <Text
        className={textModification || undefined}
        size={textSize}
        weight={textWeight}
        color={props.temporary ? 'muted' : undefined}
      >
        {props.to}
      </Text>
    </Flex>
  );
};

export default TimeRangeSection;
